import {Controller} from "@hotwired/stimulus"
import "offline-js/js/offline"

class OfflineController extends Controller {
  static targets = ["offlineMessage", "onlineMessage"]

  connect() {
    window.Offline.on("down", () => this.show_offline_message())
    window.Offline.on("up", () => this.show_online_message())
  }

  disconnect() {
    clearTimeout(this.timeout)
    window.Offline.off("down")
    window.Offline.off("up")
  }

  show_offline_message() {
    this.offlineMessageTarget.classList.remove("hide")
  }

  hide_offline_message() {
    this.offlineMessageTarget.classList.add("hide")
  }

  show_online_message() {
    this.hide_offline_message()
    this.onlineMessageTarget.classList.remove("hide")
    this.timeout = setTimeout(() => this.hide_online_message(), 3000)
  }

  hide_online_message() {
    this.onlineMessageTarget.classList.add("hide")
  }
}

export default OfflineController
